import type { MessageDescriptor } from 'react-intl';
import { FormattedMessage } from 'react-intl';

import { FullWidthContainer } from 'atoms/layout/FullWidthContainer';
import { Tab, TabBar } from 'atoms/navigation/TabBar';
import { SEARCH_PARAMS } from 'components/search/InstantSearch/types';
import { buildFilterQuery } from 'components/search/InstantSearch/utils';
import { useSettlableWalletsSearch } from 'hooks/useSettlableWalletsSearch';
import { glossary, navLabels } from 'lib/glossary';

type Props = {
  tabs: Partial<Record<TeamPageTabs, string>>;
};

export enum TeamPageTabs {
  OVERVIEW = 'OVERVIEW',
  STANDINGS = 'STANDINGS',
  FIXTURES = 'FIXTURES',
  TEAM = 'TEAM',
  CARDS = 'CARDS',
}

const tabsTitle: Record<TeamPageTabs, MessageDescriptor> = {
  [TeamPageTabs.OVERVIEW]: navLabels.overview,
  [TeamPageTabs.STANDINGS]: navLabels.standings,
  [TeamPageTabs.FIXTURES]: navLabels.fixtures,
  [TeamPageTabs.TEAM]: navLabels.team,
  [TeamPageTabs.CARDS]: glossary.cards,
};

export const Tabs = ({ tabs }: Props) => {
  const tabsToDisplay = Object.keys(tabs) as TeamPageTabs[];
  const { params } = useSettlableWalletsSearch();
  return (
    <FullWidthContainer.NoPadding>
      <TabBar variant="flat" fullWidth>
        {tabsToDisplay.map(tab => (
          <Tab
            key={tab}
            to={
              tab === TeamPageTabs.CARDS
                ? `${tabs[tab]}?${buildFilterQuery({
                    [SEARCH_PARAMS.ON_SALE]: true,
                    ...(params
                      ? { [SEARCH_PARAMS.PURCHASE_OPTIONS]: params }
                      : {}),
                  })}`
                : tabs[tab]
            }
          >
            <FormattedMessage {...tabsTitle[tab]} />
          </Tab>
        ))}
      </TabBar>
    </FullWidthContainer.NoPadding>
  );
};
